import React from 'react'
import styled, { keyframes, ThemeProvider } from 'styled-components'
import {DarkTheme} from './Themes';


import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';
import ParticleComponent from '../subComponents/ParticleComponent';
import BigTitle from '../subComponents/BigTitlte'
import astronaut from '../assets/Images/spaceman.png'

const Box = styled.div`
background-color: ${props => props.theme.body};
width: 100vw;
height:100vh;
position: relative;
overflow: hidden;
// background-color: rgb(32, 96, 153);
`
const float = keyframes`
0% { transform: translateY(-10px) }
50% { transform: translateY(15px) translateX(15px) }
100% { transform: translateY(-10px) }

`


const Spaceman = styled.div`
position: absolute;
top: 10%;
right: 5%;
width: 20vw;
animation: ${float} 4s ease infinite;
img{
    width: 100%;
    height: auto;
}
`
const Main =  styled.div`
  border: 2px solid ${(props) => props.theme.text};
  color: ${(props) => props.theme.text};
  padding: 2rem;
  width: 55vw;
  height: 60vh;
  z-index: 3;
  line-height: 1.8;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(0.3rem + 1vw);
 backdrop-filter: blur(456px);
 border-radius:3%;
  
  position: absolute;
  left: calc(4rem + 5vw);
  top: 10rem;
  font-family: 'Ubuntu Mono', monospace;
  font-style: italic;

  @media (max-width: 480px) {
    // * styles for screens with a maximum width of 480px */
    padding: 1rem;
    width: 45vw;
    font-size: 14px;
    overflow:scroll;
    line-height: 1.1;
    height:60vh;
  }
  @media (max-width: 350px) {
    // * styles for screens with a maximum width of 480px */
    padding: 0.8rem;
    width: 48vw;
    font-size: 13px;
    overflow:scroll;
    line-height: 1.0;
    left:3.5rem;
    height:65vh;
  }
`





const AboutPage = () => {
    return (
        <ThemeProvider theme={DarkTheme}>
<Box>

<LogoComponent theme='dark'/>
<SocialIcons theme='dark'/>
<PowerButton />
<ParticleComponent theme='dark' />

<Spaceman>
    <img src={astronaut} alt="spaceman" />
</Spaceman>    
<Main>
Hey there! 👋 I'm Jay, based in India, and I'm all about tech and web development.

My web development journey has been a blast! I've created user-friendly websites with HTML, CSS, and JavaScript. On the backend, I've built sturdy systems using Node.js, Express, and MongoDB.
<br/>
I'm not just about coding—I've been a key part of two startup success stories. Lately, I've been exploring the fascinating world of Web3, even joined a hackathon for a taste of the decentralized web.

Outside of tech, you'll find me on the cricket field or jamming to some tunes. Let's chat and cook up some cool projects! 🚀🏏🎵
</Main>


<BigTitle text="ABOUT" top="10%" left="5%" />

        </Box>

        </ThemeProvider>
        
    )
}

export default AboutPage
